'use client';

import { useState, useEffect, type ReactNode } from 'react';
import NativeHome from './NativeHome';

/**
 * Routes between native and web homepage.
 * On native, shows the "Today" dashboard.
 * On web, shows the marketing homepage (passed as children).
 */
export default function HomePageRouter({ children }: { children: ReactNode }) {
  const [isNativeApp, setIsNativeApp] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cap = (window as any).Capacitor;
    if (cap?.isNativePlatform?.()) {
      setIsNativeApp(true);
    }
    setChecked(true);
  }, []);

  // Don't render anything until we've checked (prevents flash of web content on native)
  if (!checked) {
    return (
      <div className="min-h-screen bg-background" />
    );
  }

  if (isNativeApp) {
    return <NativeHome />;
  }

  return <>{children}</>;
}
